import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminPageEditSidebarPageSettings = ({
  page,
  handleChange,
  handleDelete,
}) => {
  const intl = useIntl();

  return (
    <div className="page-settings">
      <FormGroup>
        <Label for="inpPageType">
          {intl.formatMessage({ defaultMessage: 'Page type' })}
        </Label>
        <Input
          type="select"
          className="custom-select"
          name="page_type"
          id="inpPageType"
          bsSize="sm"
          defaultValue={page.options.page_type}
          onChange={handleChange}
        >
          <option value="fullscreen">
            {intl.formatMessage({ defaultMessage: 'Full width' })}
          </option>
          <option value="internal">
            {intl.formatMessage({ defaultMessage: 'With sidebar' })}
          </option>
        </Input>
      </FormGroup>
      <FormGroup>
        <Button
          color="link"
          onClick={handleDelete}
        >
          <i className="far fa-trash" />
          {intl.formatMessage({ defaultMessage: 'Delete page' })}
        </Button>
      </FormGroup>
    </div>
  );
};

AdminPageEditSidebarPageSettings.propTypes = {
  page: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default AdminPageEditSidebarPageSettings;
